"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _Image = _interopRequireDefault(require("./Image.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ReactHTMLPicture = (0, _component.default)(function () {
  return import("@micado-digital/react-htmlpicture/ReactHTMLPicture");
});
var Image = function Image(_ref) {
  var _clsx;
  var absoluteMediaURLs = _ref.absoluteMediaURLs,
    media = _ref.media,
    mediaFormats = _ref.mediaFormats,
    mode = _ref.mode,
    webpFallback = _ref.webpFallback;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var css = (0, _Image.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("mco-animation-01__image", css.image, (_clsx = {}, _defineProperty(_clsx, css.backgroundImage, mode === "background"), _defineProperty(_clsx, css.hasBlurredBackgroundImage, mode === "has-blurred-background"), _clsx))
  }, /*#__PURE__*/_react.default.createElement(ReactHTMLPicture, _extends({
    lazy: false,
    media: media,
    path: !absoluteMediaURLs ? REACT_APP_PATH : "",
    webpFallback: webpFallback
  }, mediaFormats)));
};
var _default = Image;
exports.default = _default;